module.exports = __webpack_public_path__ + "img/van-hero-mobile-1.95831d5.webp";